import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { useSiteImages } from "../context/SiteImagesContext";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { resolve } = useSiteImages();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api
      .get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <main className="pt-40 pb-28 min-h-screen text-center">
        <p className="font-display text-3xl text-[#2D3732]">Artículo no encontrado</p>
        <button onClick={() => navigate("/blog")} className="mt-6 text-[#8A9A6F] link-underline">
          Volver al blog
        </button>
      </main>
    );
  }

  if (!post) return <main className="pt-40 min-h-screen" />;

  return (
    <main data-testid="blog-post-page" className="pt-32 pb-28 bg-white">
      <article className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <button
            onClick={() => navigate("/blog")}
            className="inline-flex items-center gap-2 text-sm text-[#6B705C] hover:text-[#2D3732] mb-8 transition-colors"
          >
            <ArrowLeft size={16} /> Volver al blog
          </button>
          <div className="flex items-center gap-3 mb-4">
            <span className="overline text-[#8A9A6F]">{post.category}</span>
            <span className="text-xs text-[#9CA3AF]">· {post.read_time}</span>
          </div>
          <h1 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-[1.05]">
            {post.title}
          </h1>
        </Reveal>

        <Reveal delay={0.1} className="rounded-[2rem] overflow-hidden aspect-[16/9] my-10">
          <img src={resolve(`blog:${post.slug}`, post.cover)} alt={post.title} className="w-full h-full object-cover" />
        </Reveal>

        <Reveal delay={0.15}>
          <div className="prose-vitae space-y-6 text-[#4A554E] text-lg leading-relaxed font-light">
            {post.content.split("\n\n").map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </Reveal>
      </article>
    </main>
  );
}
